import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT',
        isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'ri-dashboard-line',
        badge: {
            variant: 'success',
            text: 'MENUITEMS.DASHBOARDS.BADGE',
        },
        link: '/'
    },

    // {
    //     id: 52.5,
    //     label: 'Projects Management',
    //     icon: 'ri-archive-line',
    //     link: '/users/allusers',
    // },

    {
        id: 10.1,
        label: 'Manage InternShips',
        icon: 'ri-briefcase-4-line',   // 💼 internships = jobs/work
        link: '/internship/list',
    },
    {
        id: 10.2,
        label: 'InternShips Applications',
        icon: 'ri-file-list-3-line',   // 📄 applications list
        link: '/applications/list',
    },
    {
        id: 10.3,
        label: 'Manage Courses',
        icon: 'ri-book-open-line',    // 📘 courses
        link: '/courses/list',
    },
    {
        id: 10.4,
        label: 'Course Enrollments',
        icon: 'ri-user-add-line',     // 👤➕ enrollments
        link: '/enrollments/list',
    },

    // {
    //     id: 5.5,
    //     label: 'Order Management',
    //     icon: 'ri-truck-line',
    // },
    // {
    //     id: 54.5,
    //     label: 'Returns & Exchanges',
    //     icon: 'ri-truck-line',
    // },
    // {
    //     id: 10.2,
    //     label: 'Stock Control',
    //     icon: 'ri-store-2-line',
    // },


    // {
    //     id: 9.1,
    //     label: 'Our Brands',
    //     icon: 'ri-bill-line',
    // },
    // {
    //     id: 58.5,
    //     label: 'Our Gifts',
    //     icon: 'ri-gift-line',
    // },
    // {
    //     id: 14.1,
    //     label: 'Product Tags',
    //     icon: 'ri-price-tag-fill',
    // },
    // {
    //     id: 15.1,
    //     label: 'Reports & Analytics',
    //     icon: 'ri-file-chart-line',
    // },
    // {
    //     id: 11.1,
    //     label: 'Reviews',
    //     icon: 'ri-star-line',
    // },

    // {
    //     id: 8.8,
    //     label: 'Customers (Clients)',
    //     icon: 'ri-user-3-line',
    // },
    // {
    //     id: 5.5,
    //     label: 'Manage Users',
    //     icon: 'ri-account-circle-line',
    //     subItems: [
    //         {
    //             id: 1.1,
    //             label: 'All Users',
    //             link: '/users/allusers',
    //             parentId: 5.5
    //         },
    //         {
    //             id: 1.2,
    //             label: 'Create User',
    //             link: '/users/createuser',
    //             parentId: 5.5
    //         },
    //     ]
    // },

    {
        id: 3,
        label: 'MENUITEMS.CALENDAR.TEXT',
        icon: 'ri-calendar-2-line',
        link: '/calendar'
    },
    // =========================Manage Website=========================================================
    {
        id: 30.1,
        label: 'Manage Website',
        icon: 'ri-global-line',
        subItems: [
            {
                id: 30.2,
                label: 'Home Slider',
                link: '/homeBanner/slider',
                parentId: 30.1
            },
            {
                id: 30.3,
                label: 'Manage About Us',
                link: '/AboutUs/getAboutUs',
                parentId: 30.1
            },
            {
                id: 30.4,
                label: 'Terms & Conditions',
                link: '/users/createuser',
                parentId: 30.1
            },
        ]
    },
];
